module.exports = __webpack_public_path__ + "img/logo.09816b3d.svg";